import { render, staticRenderFns } from "./OrganisationDefaultASP.vue?vue&type=template&id=3b422712"
import script from "./OrganisationDefaultASP.vue?vue&type=script&lang=js"
export * from "./OrganisationDefaultASP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports